export function formatDate(
  date:
    | {
        month: number;
        day: number;
        year: number;
      }
    | string
    | undefined,
) {
  if (!date) {
    return date;
  }

  if (typeof date === "string") {
    const parsedDate = new Date(date);
    const month = parsedDate.getMonth() + 1;
    const day = parsedDate.getDate() + 1;
    const year = parsedDate.getFullYear();

    return `${month}/${day}/${year}`;
  }
  const { month, day, year } = date;
  return `${month}/${day}/${year}`;
}
